import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import {ActionButton} from '../components/ActionButton';
import DivContainer from '../components/DivContainer';
import CardService from '../services/CardService';
import InputDropdownComponent from '../components/inputs/InputDropdownComponent';

class CardKindDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new CardService());
        this.state = {
            cardKind: this.props.cardKind,
            cardKindOpt: [
                {enumValue: 'FIRM', label: props.t('EcCardKind.FIRM')},
                {enumValue: 'VEHICLE', label: props.t('EcCardKind.VEHICLE')},
                {enumValue: 'VEHICLE_PERSON', label: props.t('EcCardKind.VEHICLE_PERSON')},
                {enumValue: 'PERSON', label: props.t('EcCardKind.PERSON')},
            ],
        };
    }

    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate(prevProps, prevState);
        if (!prevProps.visible && this.props.visible) {
            this.setState({
                cardKind: this.props.cardKind,
            });
        }
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    prepareFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <ActionButton label={t('details.cancel')} variant={'button cancel-button white'} handleClick={this.props.onHide} />
                <ActionButton label={t('details.saveChanges')} variant='button save-button blue' handleClick={this.handleFormSubmit} />
            </div>
        );
    }
    renderHeader() {
        const {t} = this.props;
        return (
            <DivContainer colClass='col-12 transaction-dialog-header'>
                <DivContainer colClass='col-12'>
                    <label>{t('details.editButton')}</label>
                </DivContainer>
            </DivContainer>
        );
    }

    setElement() {
        this.initAfterSetElement();
    }

    createOrUpdate() {
        this.scrollToTop();
        if (this.props._isMounted) {
            this.service
                .updateCardKind({cardKind: this.state.cardKind?.enumValue, cards: this.props.cardNumbers})
                .then((response) => {
                    // this.blockUi();
                    if (this.props.handleSuccess) {
                        this.unblockUi();
                        this.props.handleSuccess(response);
                    }
                })
                .catch((err) => {
                    if (this.props.handleError) {
                        this.unblockUi();
                        this.props.handleError();
                    }
                });
        }
    }

    renderDetails() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <div className='row'>
                    <InputDropdownComponent
                        id='cardKind'
                        name='cardKind'
                        label={t('order-card.cardType')}
                        colClass='col-12'
                        value={this.state.cardKind}
                        viewMode='EDIT'
                        validator={this.validator}
                        validators='required'
                        options={this.state.cardKindOpt}
                        onChange={this.handleChange}
                        dataKey='enumValue'
                        optionLabel='label'
                        onAfterStateChange={this.changeRequiredByCardKind}
                        stateField=''
                    />
                </div>
            </React.Fragment>
        );
    }
}

CardKindDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'EDIT',
    visible: false,
};

CardKindDialog.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    cardNumbers: PropTypes.array,
};

export default withTranslation()(CardKindDialog);
